import React from 'react';
import classnames from 'classnames';
import styles from './styles.styl';

export default (props) => {
  const inputClassName = classnames(
    props.className,
    styles.container,
    { [styles.block]: props.block, [styles.error]: props.error, [styles.lower]: props.lower, },
  );

  return (
    <input
      name={props.name}
      value={props.value}
      onChange={props.onChange}
      maxLength={props.maxLength}
      placeholder={props.placeholder}
      disabled={props.disabled}
      className={inputClassName}
      readOnly={props.readOnly}
      type={props.type || 'text'}
      autoFocus={props.autoFocus}
      onBlur={props.onBlur}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/shared/Input/index.js